import React, { Component } from "react";
import "./Profile.css";
import Question from "../../../Assets/img/question.png";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";

export default class AboutUs extends Component {
  render() {
    return (
      <div className="contact">
        <Header title="درباره ما" />

        <div className="contact-fix">
          <div className="contact-body">
            <div className="contact-header">
              <div className="contact-header-pic">
                <img src={Question} alt="درباره ما" />
              </div>
              <h3>درباره آریانا پارس</h3>
            </div>

            <div className="contact-text-about">
              <p>
                موسسه مشاوره شغلی و کاریابی بین المللی آریاناپارس نوین که دارای
                مجوز رسمی از وزارت تعاون، کار و رفاه اجتماعی به شماره مجوز ۴۷۴۴۹۱
                با نام تجاری آریانا پارس است با سابقه ۷ ساله در امور کاریابی،
                اخذ اقامت کاری و اقامت دائم بر اساس توان مهارتی یا همان skilled
                worker، برخورداری از تجارب بسیار درخشان در این زمینه، آماده
                ارائه انواع خدمات مشاوره و انجام امور مرتبط با اعزام نیروی کار
                به شما هموطنان عزیز می باشد.
              </p>
              <p>
                اخذ نمایندگی از بسیاری دانشگاه ها و مراکز معتبر جهان، ارائه
                صدها پرونده موفق به چندین سفارت کشورهای مختلف دنیا و ایجاد
                رابطه مبتنی بر رضایت قلبی و اطمینان خاطر موکلین عزیز همواره
                بزرگترین افتخار این موسسه بوده و سرلوحه عملکرد آتی آن نیز خواهد
                بود.
              </p>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    );
  }
}